import type { BaseSectionHeaderProps } from './types';
import { resolveBaseAppearance } from './theme';
import { cn, hasRenderableNode } from './utils';

export function BaseSectionHeader({
  eyebrow,
  title,
  description,
  actions,
  children,
  appearance,
  className,
  classNames,
  style,
  ...headerProps
}: BaseSectionHeaderProps) {
  const theme = resolveBaseAppearance(appearance);
  const resolvedDescription = children ?? description;

  return (
    <div
      {...headerProps}
      className={cn(theme.slots.sectionHeaderRoot, classNames?.root, className)}
      style={{
        ...theme.styles.sectionHeader,
        ...style,
      }}
    >
      <div
        className={cn(theme.slots.sectionHeaderContent, classNames?.content)}
      >
        {hasRenderableNode(eyebrow) ? (
          <div
            className={cn(
              theme.slots.sectionHeaderEyebrow,
              classNames?.eyebrow,
            )}
          >
            {eyebrow}
          </div>
        ) : null}
        {hasRenderableNode(title) ? (
          <div className={cn(theme.slots.sectionHeaderTitle, classNames?.title)}>
            {title}
          </div>
        ) : null}
        {hasRenderableNode(resolvedDescription) ? (
          <div
            className={cn(
              theme.slots.sectionHeaderDescription,
              classNames?.description,
            )}
          >
            {resolvedDescription}
          </div>
        ) : null}
      </div>

      {hasRenderableNode(actions) ? (
        <div className={cn(theme.slots.sectionHeaderActions, classNames?.actions)}>
          {actions}
        </div>
      ) : null}
    </div>
  );
}
